import CheckBoxV2 from './CheckBoxV2';

export default CheckBoxV2;
